import _ from "lodash";
import React from "react";

import { withLayout } from "../../components";
import { withHelpContent } from "./withHelpContent";
import { HelpNavigation } from "./HelpNavigation/HelpNavigation";
import { HelpContent } from "./HelpContent/HelpContent";
import { HelpHeader } from "./HelpHeader/HelpHeader";
import { withHighlightContext } from "./HighlightContext/HighlightContext";

import "./HelpPage.scss";

const HelpPageContent = () => {
  return (
    <div className="help-page">
      <div className="help-page__sidebar">
        <div className="help-page__sidebar-container">
          <HelpNavigation />
        </div>
      </div>
      <div className="help-page__content">
        <div className="help-page__content-container">
          <HelpContent />
        </div>
      </div>
    </div>
  );
};

export const HelpPage = _.flowRight([
  withHighlightContext,
  withLayout({
    customHeader: () => <HelpHeader />,
  }),
  withHelpContent,
])(HelpPageContent);
